export default "__VITE_ASSET__Dt3TSWOZ__"